import type { ReportExportFormat, ReportParamKind, ReportResult } from '@qms360/shared';
import { apiFetch, apiFetchBlob } from './api.js';

/** The Reports Hub (spec §13.8). */

export interface ReportSummary {
  key: string;
  label: string;
  description: string;
  params: ReportParamKind[];
  required: ReportParamKind[];
}

export type ReportFilters = Partial<Record<ReportParamKind, string>>;

function query(filters: ReportFilters, extra: Record<string, string> = {}): string {
  const params = new URLSearchParams(extra);
  for (const [key, value] of Object.entries(filters)) if (value) params.set(key, value);
  const text = params.toString();
  return text ? `?${text}` : '';
}

export const fetchReportList = (app: string) =>
  apiFetch<{ reports: ReportSummary[]; canExport: boolean }>(`/reports${query({}, { app })}`);

export const fetchReport = (key: string, filters: ReportFilters) =>
  apiFetch<{ report: ReportResult }>(`/reports/${encodeURIComponent(key)}${query(filters)}`);

export async function downloadReport(key: string, filters: ReportFilters, format: ReportExportFormat): Promise<void> {
  const blob = await apiFetchBlob(`/reports/${encodeURIComponent(key)}/export${query(filters, { format })}`);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `qms360-${key.replace(/[^a-z0-9]+/gi, '-')}-${new Date().toISOString().slice(0, 10)}.${format}`;
  link.click();
  URL.revokeObjectURL(url);
}
